import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export type SettingsTab =
  | 'general'
  | 'queries'
  | 'clients'
  | 'datasources'
  | 'notifications'

const ALLOWED_TABS: ReadonlySet<SettingsTab> = new Set([
  'general',
  'queries',
  'clients',
  'datasources',
  'notifications',
])

function isValidTab(value: string): value is SettingsTab {
  return ALLOWED_TABS.has(value as SettingsTab)
}

export function useSettingsTab(): {
  activeTab: SettingsTab
  setTab: (next: SettingsTab) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()

  const raw = searchParams.get('tab') ?? ''
  const activeTab: SettingsTab = isValidTab(raw) ? raw : 'general'

  const setTab = useCallback(
    (next: SettingsTab) => {
      setSearchParams({ tab: next }, { replace: true })
    },
    [setSearchParams],
  )

  return { activeTab, setTab }
}
